import styled from "@emotion/styled";
export const Right = styled.div`
  grid-area: right;

  display: none;

  > * + * {
    margin-block-start: 40px;
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    display: flex;
    flex-flow: column nowrap;
  }
`;
